import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

@Component({
  selector: 'app-app-footer',
  imports: [CommonModule],
  templateUrl: './app-footer.component.html',
  styleUrl: './app-footer.component.scss',
  standalone: true,
})
export class AppFooterComponent {
  currentYear = new Date().getFullYear();

  menus = [
    {
      title: 'Magánszemélyeknek',
      items: [
        {
          label: 'Csomagküldés',
          url: 'https://foxpost.hu/csomagkuldes',
        },
        {
          label: 'Csomagátvétel',
          url: 'https://foxpost.hu/csomagatvetel',
        },
        {
          label: 'Csomagautomaták',
          url: 'https://foxpost.hu/csomagautomatak',
        },
        {
          label: 'Áraink',
          url: 'https://foxpost.hu/araink',
        },
        {
          label: 'Ügyfélszolgálat',
          url: 'https://foxpost.hu/ugyfelszolgalat',
        },
        {
          label: 'Számlaigénylés',
          url: 'https://foxpost.hu/afa-s-szamla-igenylo-urlap',
        },
      ],
    },
    {
      title: 'Üzleti partnereknek',
      items: [
        {
          label: 'Üzleti csomagfeladás',
          url: 'https://foxpost.hu/uzleti-partnereknek/uzleti-csomagfeladas',
        },
        {
          label: 'Automata kereső',
          url: 'https://foxpost.hu/uzleti-partnereknek/automata-kereso',
        },
        {
          label: 'Első lépések',
          url: 'https://foxpost.hu/uzleti-partnereknek/megjelenesi-utmutato',
        },
        {
          label: 'Üzleti áraink',
          url: 'https://foxpost.hu/uzleti-partnereknek/araink-uzleti-partnereknek',
        },
        {
          label: 'Üzleti ügyfélszolgálat',
          url: 'https://foxpost.hu/uzleti-partnereknek/segithetunk',
        },
      ],
    },
    {
      title: '',
      items: [
        {
          label: 'Foxpostról',
          url: 'https://foxpost.hu/foxpostrol',
        },
        {
          label: 'Blog',
          url: 'https://foxpost.hu/blog-lista',
        },
        {
          label: 'Üzleti partnereink',
          url: 'https://foxpost.hu/partnereink',
        },
        {
          label: 'Kapcsolat',
          url: 'https://foxpost.hu/kapcsolat',
        },
        {
          label: 'Fizetés',
          url: 'https://foxpost.hu/fizetes',
        },
        {
          label: 'Adathalászat',
          url: 'https://foxpost.hu/adathalaszat',
        },
      ],
    },
    {
      title: '',
      items: [
        {
          label: 'Impresszum',
          url: 'https://foxpost.hu/impresszum',
        },
        {
          label: 'ÁSZF és adatkezelés',
          url: 'https://foxpost.hu/altalanos-szerzodesi-feltetelek',
        },
        {
          label: 'Adatkezelés partnereknek',
          url: 'https://foxpost.hu/uploads/documents/hu/foxpost_adatkezeles.pdf',
        },
        {
          label: 'Karrier',
          url: 'https://foxpost.hu/karrier',
        },
        {
          label: 'Új aktiváló email',
          url: 'https://foxpost.hu/aktivalo-email-keres',
        },
        {
          label: 'Fenntarthatóság',
          url: 'https://foxpost.hu/fenntarthatosag',
        },
      ],
    },
  ];
}
